import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  TriggerHealthCheck,
  FinishHealthCheck,
  TriggerPhishboxHealthCheck,
  FinishPhishboxHealthCheck,
  TriggerHunterboxHealthCheck,
  FinishHunterboxHealthCheck,
  SuccessCoreResponsibles,
  FailureCoreResponsibles,
  SuccessInternetStatus,
  FailureInternetStatus,
  SuccessVpnStatus,
  FailureVpnStatus,
  SuccessAnalyserStatus,
  FailureAnalyserStatus,
  SuccessReporterStatus,
  FailureReporterStatus,
  SuccessBrokerStatus,
  FailureBrokerStatus,
  SuccessDiskStatus,
  FailureDiskStatus,
  SuccessFtiStatus,
  FailureFtiStatus,
  SuccessMlStatus,
  FailureMlStatus,
  SuccessCdrStatus,
  FailureCdrStatus,
  SuccessPhishStatus,
  FailurePhishStatus,
  SuccessRabbitStatus,
  FailureRabbitStatus,
  SuccessZsearchStatus,
  FailureZsearchStatus,
  SuccessMongoStatus,
  FailureMongoStatus,
  SuccessPhishboxInternetStatus,
  FailurePhishboxInternetStatus,
  SuccessAgenterStatus,
  FailureAgenterStatus,
} from "../actions/healthCheckActions";

import axiosApi from "../../utils/axios";

export function* coreResponsibles() {
  try {
    const response = yield call(axiosApi.get, "/api/health-check/core-responsibles");
    yield put(SuccessCoreResponsibles(response.data));
  } catch (err) {
    yield put(FailureCoreResponsibles());
  }
}

export function* internetStatus() {
  try {
    const response = yield call(axiosApi.get, "/api/health-check/internet");
    yield put(SuccessInternetStatus(response.data["internet-status"]));
  } catch (err) {
    yield put(FailureInternetStatus());
  }
}

export function* vpnStatus() {
  try {
    const response = yield call(axiosApi.get, "/api/health-check/vpn");
    yield put(SuccessVpnStatus(response.data["vpn-status"]));
  } catch (err) {
    yield put(FailureVpnStatus());
  }
}

export function* analyserStatus() {
  try {
    const response = yield call(axiosApi.get, "/api/health-check/analyser");
    yield put(SuccessAnalyserStatus(response.data["analyser-status"]));
  } catch (err) {
    yield put(FailureAnalyserStatus());
  }
}

export function* reporterStatus() {
  try {
    const response = yield call(axiosApi.get, "/api/health-check/reporter");
    yield put(SuccessReporterStatus(response.data["reporter-status"]));
  } catch (err) {
    yield put(FailureReporterStatus());
  }
}

export function* brokerStatus() {
  try {
    const response = yield call(axiosApi.get, "/api/health-check/broker");
    yield put(SuccessBrokerStatus(response.data["broker-status"]));
  } catch (err) {
    yield put(FailureBrokerStatus());
  }
}

export function* diskStatus() {
  try {
    const response = yield call(axiosApi.get, "/api/health-check/disk");
    yield put(SuccessDiskStatus(response.data));
  } catch (err) {
    yield put(FailureDiskStatus());
  }
}

export function* ftiStatus() {
  try {
    const response = yield call(axiosApi.get, "/api/health-check/fti");
    yield put(SuccessFtiStatus(response.data["fti-status"]));
  } catch (err) {
    yield put(FailureFtiStatus());
  }
}

export function* mlStatus() {
  try {
    const response = yield call(axiosApi.get, "/api/health-check/ml");
    yield put(SuccessMlStatus(response.data["ml-status"]));
  } catch (err) {
    yield put(FailureMlStatus());
  }
}

export function* phishStatus() {
  try {
    const response = yield call(axiosApi.get, "/api/health-check/phish");
    yield put(SuccessPhishStatus(response.data["phish-status"]));
  } catch (err) {
    yield put(FailurePhishStatus());
  }
}

export function* cdrStatus() {
  try {
    const response = yield call(axiosApi.get, "/api/health-check/cdr");
    yield put(SuccessCdrStatus(response.data["cdr-status"]));
  } catch (err) {
    yield put(FailureCdrStatus());
  }
}

export function* rabbitStatus() {
  try {
    const response = yield call(axiosApi.get, "/api/health-check/rabbit");
    yield put(SuccessRabbitStatus(response.data["rabbit-status"]));
  } catch (err) {
    yield put(FailureRabbitStatus());
  }
}

export function* mongoStatus() {
  try {
    const response = yield call(axiosApi.get, "/api/health-check/mongo");
    yield put(SuccessMongoStatus(response.data["mongo-status"]));
  } catch (err) {
    yield put(FailureMongoStatus());
  }
}

export function* zsearchStatus() {
  try {
    const response = yield call(axiosApi.get, "/api/health-check/zsearch");
    yield put(SuccessZsearchStatus(response.data["zsearch-status"]));
  } catch (err) {
    yield put(FailureZsearchStatus());
  }
}

export function* phishboxInternetStatus() {
  try {
    const response = yield call(axiosApi.get, "/api/phishbox/internet-connection");
    yield put(SuccessPhishboxInternetStatus(response.data["internet"]));
  } catch (err) {
    yield put(FailurePhishboxInternetStatus());
  }
}

export function* agenterStatus() {
  try {
    const response = yield call(axiosApi.get, "/api/agent/alive-all");
    yield put(SuccessAgenterStatus(response.data["agenter_status"]));
  } catch (err) {
    yield put(FailureAgenterStatus());
  }
}

function* rootSaga() {
  try {
    yield all([
      call(coreResponsibles),
      call(internetStatus),
      call(vpnStatus),
      call(analyserStatus),
      call(reporterStatus),
      call(brokerStatus),
      call(diskStatus),
      call(ftiStatus),
      call(mlStatus),
      call(cdrStatus),
      call(phishStatus),
      call(rabbitStatus),
      call(mongoStatus),
      call(zsearchStatus),
    ]);
    yield put(FinishHealthCheck());
  } catch (e) {
    yield put(FinishHealthCheck());
  }
}

function* phishboxRootSaga() {
  try {
    yield all([call(phishboxInternetStatus), call(brokerStatus), call(phishStatus)]);
    yield put(FinishPhishboxHealthCheck());
  } catch (e) {
    yield put(FinishPhishboxHealthCheck());
  }
}

function* hunterboxRootSaga() {
  try {
    yield all([call(brokerStatus), call(agenterStatus)]);
    yield put(FinishHunterboxHealthCheck());
  } catch (e) {
    yield put(FinishHunterboxHealthCheck());
  }
}

const healthCheckSagas = [
  takeLatest(TriggerHealthCheck, rootSaga),
  takeLatest(TriggerPhishboxHealthCheck, phishboxRootSaga),
  takeLatest(TriggerHunterboxHealthCheck, hunterboxRootSaga),
];

export default healthCheckSagas;
